module.exports = __webpack_public_path__ + "img/sample-cooperate-introduce.fff2cc05.png";